export const InventoryListColConfig = [
  {
    columnKey: 'productId',
    header: 'PRODUCT ID',
    columnFilterPlaceholder: 'Product ID',
  },
  {
    columnKey: 'warehouseId',
    header: 'WAREHOUSE ID',
    columnFilterPlaceholder: 'Warehouse ID',
  },
  {
    columnKey: 'gtin',
    header: 'GTIN',
    columnFilterPlaceholder: 'GTIN',
  },
  {
    columnKey: 'parentId',
    header: 'PARENT ID',
    columnFilterPlaceholder: 'Parent ID',
  },
  {
    columnKey: 'stock',
    header: 'STOCK',
    columnFilterPlaceholder: 'Stock',
  },
  {
    columnKey: 'daysOnStock',
    header: 'DAYS ON STOCK',
    columnFilterPlaceholder: 'Days On Stock',
    filterVariant: 'double',
  },
  {
    columnKey: 'lastUpdated',
    header: 'LAST UPDATED',
    filterVariant: 'date',
    initialSize: 240,
    columnFilterPlaceholder: 'Last Updated',
  },
]
